import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import * as API from '../../framework/API/api';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import BossDialog from '../../components/BossDialog';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { ENTITYNAME, LOCALSTORAGE_KEY, MEDIACATEGORIES, MILLISECONDSINADAY } from '../../framework/constant/constant';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { TimeRangePicker } from '../../framework/forms/helpercomponents/timepicker/TimeRangePicker';
import { CheckboxCell } from '../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { EditPageHeader } from '../../components/EditPageHeader';
import { utility } from '../../framework/utility/utilityProvider';
import { toast } from 'react-toastify';
import { ArrayCell } from '../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import moment from 'moment';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import { PlanningHelper } from './helper/PlanningHelper';

const PlanningInsertDummyPopup = (props) => {

    const { selectedSlot, onClose, isRightClick = false, getSelectedChannel, addPlanningItem, multiple, channel, isPrimeTime } = props;

    const { FirstDate, LastDate } = utility.getFirstAndLastDateOfMonth(selectedSlot?.SlotDateTime);
    let isMultiple = multiple ?? false;
    const lang = useTranslation();
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
    //OLD
    // let offSetHours = isPrimeTime ? 0 : new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
    //NEW
    let offSetHours = isPrimeTime ? 0 : new Date(PlanningHelper.getDayStartTime(getSelectedChannel ? [getSelectedChannel(selectedSlot?.channelIndex)] : [channel[0]]) ?? 0).getUTCHours();

    let offSetTime = offSetHours * 3600000;

    let slotDate = selectedSlot?.SlotDateTime ? moment(selectedSlot?.SlotDateTime).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
    let slotTime = selectedSlot?.SlotDateTime ? 
            multiple ? moment(selectedSlot?.SlotDateTime).format("HH:mm") : moment(selectedSlot?.SlotDateTime).utc().format("HH:mm") 
        : "00:00"
    
    const blankDataItem = {
        FromDate : FirstDate,
        ToDate : LastDate,
        Days: [],
        SlotTime: utility.convertMilisecondsToShortTimeString(utility.convertShortTimeStringToMilliSeconds(slotTime) + offSetTime),
        SlotDate: slotDate,
        Duration: "01:00:00:00",
        Title: "",
        Genre: [],
        Type: {},
        BreakTemplate: []
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [genres, setGenres] = useState([]);
    const [showSelectBreakTemplate, setShowSelectBreakTemplate] = useState(false);
    const [types, setTypes] = useState([]);
    const [repeatPatternData, setRepeatPatternData] = useState({});
    const [timeBlocks, setTimeBlocks] = useState([0, 1, 2]);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const daysOfWeek = [
        { short: 'Sun' }, { short: 'Mon' }, { short: 'Tue' },
        { short: 'Wed' }, { short: 'Thu' }, { short: 'Fri' }, { short: 'Sat' }
    ];

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let genRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenres(genRes.data);
        let mediaCategoryRes = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { Description: 1 } });
        let mediaSubCategoryTypeRes = await API.getDataLookup(ENTITYNAME.MediaSubCategoryType, { sort: { Description: 1 } });
        if(company && company.Name.toLowerCase() == "rotana"){
            setTypes(mediaSubCategoryTypeRes.data);
        } else {
            setTypes(mediaCategoryRes.data);
        }
    };

    const onChange = (e) => {
        if (e.target.name == "Repeat") {
            setRepeatPatternData({ ...repeatPatternData, Repeat: !repeatPatternData.Repeat });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const handleDayToggle = (index) => {
        const updatedDays = [...dataItem.Days];
        if (updatedDays.includes(index)) {
            updatedDays.splice(updatedDays.indexOf(index), 1);
        } else {
            updatedDays.push(index);
        }
        setDataItem({ ...dataItem, Days: updatedDays });
    };

    const clearBreakTemplate = () => {
        setDataItem({ ...dataItem, BreakTemplate: "" });
    };

    const handleBreakFormat = (dataList) => {
        if (dataList && dataList.length > 0) {
            const selectedFormat = dataList[0];
            setDataItem(prev => ({
                ...prev,
                BreakTemplate: selectedFormat.Name
            }));
            setShowSelectBreakTemplate(false);
        }
    };

    const getNextDay = (day) => {
        const idx = days.indexOf(day);
        return days[(idx + 1) % 7];
    };

    const convertTimeToMilliseconds = (hhmm) => {
        if (!hhmm) return 0;
        const [h, m] = hhmm.split(":").map(Number);
        return (h * 60 + m) * 60000;
    };

    const generateSchedule = (formData) => {
        let result = [];
        let primaryIndex = 1;

        for (let day of days) {
            const mainTime = formData[`${day}time`];
            let count = mainTime ? 1 : 0;

            for (let block of timeBlocks) {
                if (formData[`${day}_time_${block}`]) {
                    count++;
                }
            }

            if (mainTime) {
                result.push({
                    _id: `${primaryIndex}_0`,
                    Type: "Primary",
                    PrimaryEventsNo: primaryIndex,
                    RepeatEventsNo: 0,
                    Days: day,
                    NominalStart: convertTimeToMilliseconds(mainTime)
                });

                for (let i = 0; i < timeBlocks.length; i++) {
                    const block = timeBlocks[i];
                    const repeatTime = formData[`${day}_time_${block}`];
                    const isRepeat = formData[`${day}_repeat_${block}`];
                    const nextDay = formData[`${day}_nextDay_${block}`];

                    if (repeatTime && isRepeat) {
                        result.push({
                            _id: `${primaryIndex}_${i + 1}`,
                            Type: "Repeat",
                            PrimaryEventsNo: primaryIndex,
                            RepeatEventsNo: i + 1,
                            Days: nextDay ? getNextDay(day) : day,
                            NominalStart: convertTimeToMilliseconds(repeatTime)
                        });
                    }
                }

                primaryIndex++;
            }
        }
        return result;
    };

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        const updated = { ...repeatPatternData };

        const selectAllRepeatMatch = name.match(/^SelectAllRepeat_block_(\d+)$/);
        const selectAllNextDayMatch = name.match(/^SelectAllNextDay_block_(\d+)$/);

        if (selectAllRepeatMatch) {
            const blockIndex = selectAllRepeatMatch[1];
            updated[name] = checked;
            days.forEach((day) => {
                updated[`${day}_repeat_${blockIndex}`] = checked;
            });
        } else if (selectAllNextDayMatch) {
            const blockIndex = selectAllNextDayMatch[1];
            updated[name] = checked;
            days.forEach((day) => {
                updated[`${day}_nextDay_${blockIndex}`] = checked;
            });
        } else {
            updated[name] = type === "checkbox" ? checked : value;
        }

        setRepeatPatternData(updated);
        if (updated.showRepeatPattern) {
            generateSchedule(updated);
        }
    };

    const handleTimeAutoFormat = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/\D/g, '');
        let formatted = numericValue;
        if (numericValue.length > 2) {
            formatted = numericValue.slice(0, 2) + ':' + numericValue.slice(2, 4);
        }
        if (formatted.length > 5) {
            formatted = formatted.slice(0, 5);
        }
        setRepeatPatternData({ ...repeatPatternData, [name]: formatted });
    };

    const isValidToAdd = () => {

        if(isMultiple && !dataItem.FromDate){
            toast.error(lang.please_select_from_date_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }

        if(isMultiple && !dataItem.ToDate){
            toast.error(lang.please_select_to_date_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }

        if(!dataItem.Title){
            toast.error(lang.please_enter_title_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }

        if(!dataItem.Genre || Object.keys(dataItem.Genre).length === 0){
            toast.error(lang.please_select_genre_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }

        if(!isMultiple && !dataItem.SlotDate){
            toast.error(lang.please_enter_slot_date_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }

        if(!dataItem.SlotTime){
            toast.error(lang.please_enter_slot_time_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }

        if(!dataItem.Duration || dataItem.Duration <= 0){
            toast.error(lang.please_enter_duration_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }

        if(!repeatPatternData?.showRepeatPattern && (!Array.isArray(dataItem.Days) || dataItem.Days.length === 0)){
            toast.error(lang.please_select_days_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }

        if(repeatPatternData?.showRepeatPattern){
            let repPat = generateSchedule(repeatPatternData)
            if(repPat.length === 0){
                toast.error(lang.please_select_repeat_pattern_error_message, {
                    position: toast.POSITION.TOP_RIGHT
                })
                return false
            }
        }

        return true

    }

    const handleAddDays = () => {

        if (!isValidToAdd()) return;

        let newEntries = [];
        
        // CREATE ENTERIES ON THE BASIS OF SELECT FROM DATE - TO DATE
        // Main data

        // IS REPEAT PATTERN
        if (repeatPatternData?.showRepeatPattern) {

            let baseEntries = []

            let repPatData = generateSchedule(repeatPatternData)

            let tempFromDate = utility.convertStringDatetoMilliseconds(dataItem.FromDate);
            let endDateInMili = utility.convertStringDatetoMilliseconds(dataItem.ToDate);

            while (tempFromDate <= endDateInMili) {

                let date = tempFromDate

                let dateDay = new Date(tempFromDate).getDay();

                let repPatItems = repPatData.filter((x) => x.Days == days[dateDay]);

                if (repPatItems.length > 0) {
                    for (let i = 0; i < repPatItems.length; i++) {
                        const dummy = repPatItems[i];
                        baseEntries.push({
                            ...dataItem,
                            SlotDate: utility.convertMilisecondsToDateString(date),
                            SlotTime: utility.convertMilisecondsToStringWithFrames(dummy.NominalStart),
                            Days: dummy.Days,
                            Type: dataItem?.Type,
                            Genre: dataItem?.Genre,
                            // RepeatPattern: repeatPatternData?.showRepeatPattern ? generateSchedule(repeatPatternData, [dayIndex]) : null,
                            BreakTemplate: dataItem?.BreakTemplate || '',
                            id: Date.now() + days.indexOf(dummy.Days),
                        })

                    }
                }

                tempFromDate = tempFromDate + MILLISECONDSINADAY

            }

            newEntries.push(...baseEntries);

        } else {

            let baseEntries = []
            dataItem.Days.map((dayIndex) => {

                //GET ALL THE DATE OF THE DAY IN SELECT DATE RANGE ( FROM DATE - TO DATE )
                let daysDate = utility.getDatesByDay(dataItem.FromDate, dataItem.ToDate, dayIndex);
                console.log(daysDate)
                console.log(dataItem.SlotTime)

                if (daysDate.length != 0) {

                    daysDate.map((date) => {

                        let stringDate = moment(date).format('YYYY-MM-DD');

                        baseEntries.push({
                            ...dataItem,
                            SlotDate: utility.convertMilisecondsToDateString(new Date(stringDate).getTime()),
                            SlotTime: dataItem?.SlotTime,
                            Days: days[dayIndex],
                            Type: dataItem?.Type,
                            Genre: dataItem?.Genre,
                            RepeatPattern: repeatPatternData?.showRepeatPattern ? generateSchedule(repeatPatternData, [dayIndex]) : null,
                            BreakTemplate: dataItem?.BreakTemplate || '',
                            id: Date.now() + dayIndex,
                        })

                    })

                }

            });

            newEntries.push(...baseEntries);

        }
        
        setGridData(prev => [...prev, ...newEntries]);
        setDataItem({ ...blankDataItem, Genre: [] });
        setRepeatPatternData({});
    }; 

    const isValid = () => {
        if (!dataItem.Title || dataItem.Title == "") {
            toast.error(lang.please_enter_title_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false;
        }
        return true;
    }

    const onInsertDummyPlanning = async () => {

        if (!isMultiple && !isValid()) return;

        let isRotana = company.Name.toLowerCase() == "rotana";

        let dummyToSave = [];

        if (isMultiple) {

            // CREATE DUMMY ENTRIES
            gridData.map((data) => {
                let payload = {
                    title: data.Title,
                    genres: (data.Genre && data.Genre.length > 0) ? data.Genre.map(x => { return { _id: x?._id, Description: x?.Description, SID: x?.SID } }) : [],
                    slotTime: data.SlotTime ? utility.convertShortTimeStringToMilliSeconds(data.SlotTime) - offSetTime: 0,
                    slotDate: data.SlotDate ? utility.convertStringDatetoMilliseconds(data.SlotDate) : 0,
                    duration: utility.convertStringWithFramesToMilliseconds(data.Duration),
                    isDummy: true,

                    //BY DEFAULT DUMMY IS PROGRAM
                    mediaCategory: (data.Type && Object.keys(data.Type).length > 0) ? {
                        SID: isRotana ? data.Type?.MediaCategorySID : data.Type?.SID,
                        Description: isRotana ? utility.getKeyByValue(MEDIACATEGORIES, data.Type?.MediaCategorySID) : data.Type?.Description
                    } : { Description: utility.getKeyByValue(MEDIACATEGORIES, MEDIACATEGORIES.Program), SID: MEDIACATEGORIES.Program }
                }

                dummyToSave.push(payload)

            })

        } else {
            dummyToSave = [{
                title: dataItem.Title,
                genres: (dataItem.Genre && dataItem.Genre.length > 0) ? dataItem.Genre.map(x => { return { _id: x?._id, Description: x?.Description, SID: x?.SID } }) : [],
                slotTime: dataItem.SlotTime ? utility.convertShortTimeStringToMilliSeconds(dataItem.SlotTime) - offSetTime : 0,
                slotDate: dataItem.SlotDate ? utility.convertStringDatetoMilliseconds(dataItem.SlotDate) : 0,
                duration: utility.convertStringWithFramesToMilliseconds(dataItem.Duration),
                isDummy: true,

                //BY DEFAULT DUMMY IS PROGRAM
                mediaCategory: (dataItem.Type && Object.keys(dataItem.Type).length > 0) ? {
                    SID: isRotana ? dataItem.Type?.MediaCategorySID : dataItem.Type?.SID,
                    Description: isRotana ? utility.getKeyByValue(MEDIACATEGORIES, dataItem.Type?.MediaCategorySID) : dataItem.Type?.Description
                } : { Description: utility.getKeyByValue(MEDIACATEGORIES, MEDIACATEGORIES.Program), SID: MEDIACATEGORIES.Program }
            }]
        }


        console.log(dummyToSave)
        let dummyMediaRes = await API.getDummyMedia(dummyToSave);

        if (dummyMediaRes.success) {

            let dummyMediaEpisodes = dummyMediaRes.data;

            for (let i = 0; i < dummyToSave.length; i++) {
                const dummy = dummyToSave[i];
                //INSERT DUMMY IN PLANNING
                let startDateTime = dummy.slotDate + dummy.slotTime;
                let selectedChannelIndex = selectedSlot?.channelIndex;
                let selectedChannel = getSelectedChannel ? getSelectedChannel(selectedChannelIndex) : channel[0];
                let media = dummyMediaEpisodes.find((x) => x.Title == dummy.title);
                let duration = typeof media.Duration == "string" ? utility.convertStringWithFramesToMilliseconds(media.Duration) : media.Duration

                console.log('----')
                console.log(startDateTime)
                console.log(selectedChannel)
                console.log(media)
                console.log('----')

                console.log("insert dummy called");

                await addPlanningItem(
                    new Date(startDateTime),
                    selectedChannel,
                    media,
                    null,
                    false,
                    media.Title,
                    duration
                );

            }
            props.onClose()
        } else {
            toast.error(dummyMediaRes.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            console.log(dummyMediaRes)
        }
    }

    return (
        <BossDialog title={lang.dummy_planning_dialog_header} width={"900px"} onClose={onClose}>
            <EditPageHeader showTitle={false} onSubmit={onInsertDummyPlanning} onCancel={onClose} />
            {isMultiple && <div className='row mt-2'>
                <div className='col-6'>
                    <label htmlFor="">{lang.from_date_label} *</label>
                    <input
                        type="date"
                        className="form-control form-control-sm"
                        name="FromDate"
                        defaultValue={dataItem.FromDate}
                        value={dataItem.FromDate}
                        onChange={onChange}
                    />
                </div>
                <div className='col-6'>
                    <label htmlFor="">{lang.to_date_label} *</label>
                    <input
                        type="date"
                        className="form-control form-control-sm"
                        name="ToDate"
                        value={dataItem.ToDate}
                        onChange={onChange}
                    />
                </div>
            </div>}
            <div className='row mt-1'>

                <div className="col-6">
                    <label>{lang.title_label} *</label>
                    <input type='text' className="form-control form-control-sm" name='Title' value={dataItem.Title} onChange={onChange} />
                </div>
                <div className='col-6'>
                    <label htmlFor="TabView">{lang.genre_label} *</label>
                    <MultiSelect
                        data={genres}
                        name="Genre"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Genre}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className='row mt-1'>
                {!isMultiple && <div className='col-3'>
                    <label>{lang.slot_date_label} *</label>
                    <input type='date' className="form-control form-control-sm" name='SlotDate' value={dataItem.SlotDate} onChange={onChange} />
                </div>}
                <div className={`col-${isMultiple ? '6' : '3'}`}>
                    <label>{lang.slot_time_label} *</label>
                    <TimeRangePicker
                        name="SlotTime"
                        value={dataItem.SlotTime}
                        onChange={onChange}
                    />
                </div>
                <div className="col-6">
                    <label htmlFor="">{lang.duration_label} *</label>
                    <TimePickerWithFormat
                        name="Duration"
                        value={dataItem.Duration}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className='row mt-2'>
                <div className='col-6'>
                    <label>{lang.break_template_label}</label>
                    <div className='d-flex'>
                        <input
                            name="BreakTemplate"
                            style={{ width: "800px" }}
                            type="text"
                            className="form-control form-control-sm"
                            value={dataItem?.BreakTemplate ?? ''}
                            disabled
                        />
                        <ActionButton style={{ height: "30px" }} btnColor={"success"} title={lang.select_button_tooltip} name={"..."} onClick={() => setShowSelectBreakTemplate(true)} />
                        <ActionButton style={{ height: "30px" }} btnColor={"danger"} title={lang.remove_filtter_button_tooltip} name={""} icon={"xmark"} onClick={clearBreakTemplate} />
                    </div>
                </div>
                <div className='col-6'>
                    <label htmlFor='TabView'>{lang.category_type_label} *</label>
                    <DropDownList
                        data={types}
                        name='Type'
                        dataItemKey='_id'
                        textField='Description'
                        onChange={onChange}
                        value={dataItem.Type}
                    />
                </div>
            </div>
            {!isRightClick && <>
                {!repeatPatternData.showRepeatPattern && <div className="form-group d-flex align-items-start mt-4">
                    <div style={{ position: 'relative' }}>
                        <div
                            className="d-flex align-items-center justify-content-between"
                            style={{ position: 'absolute', right: 0, top: '-17px', left: 0 }}
                        >
                            <label style={{ margin: 0 }}>Days:</label>

                            <label
                                className="d-flex align-items-center mb-1"
                                style={{ fontSize: '14px', cursor: 'pointer', margin: 0 }}
                            >
                                <input
                                    type="checkbox"
                                    className="mr-1"
                                    checked={dataItem.Days.length === 7}
                                    onChange={(e) => {
                                        setDataItem({
                                            ...dataItem,
                                            Days: e.target.checked ? [0, 1, 2, 3, 4, 5, 6] : [],
                                        });
                                    }}
                                />
                                {lang.select_all_label}
                            </label>
                        </div>
                        <div className="d-flex flex-wrap p-1 rounded mt-2"
                            style={{ border: '1px dotted', width: 'fit-content', minWidth: '350px', boxSizing: 'border-box' }} >
                            {daysOfWeek.map((day, index) => {
                                const isSelected = dataItem.Days.includes(index);
                                return (
                                    <label
                                        key={index}
                                        className="mr-2 mb-1"
                                        style={{ cursor: 'pointer', fontSize: '14px', minWidth: '50px' }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => handleDayToggle(index)}
                                            className="mr-1"
                                        />
                                        {day.short}
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                </div>}
                <div className="table-responsive mt-2 border p-1">
                    <label htmlFor="TabView" style={{ fontSize: "15px" }}>{lang.repeat_pattern_label}</label>
                    <input type="checkbox" style={{ border: '1px solid grey', marginLeft: "5px" }} name={"showRepeatPattern"} checked={repeatPatternData.showRepeatPattern} value={repeatPatternData.showRepeatPattern} onChange={handleChange} />
                    {repeatPatternData.showRepeatPattern && (<>
                        <table className="table table-bordered align-middle table-sm mt-2" style={{ fontSize: '12px' }}>
                            <thead>
                                <tr>
                                    <th className="text-nowrap p-1" style={{ width: '40px' }}>Days</th>
                                    <th className="text-nowrap p-1" style={{ width: '98px' }}>Time</th>
                                    {timeBlocks.map((block, i) => (
                                        <React.Fragment key={i}>
                                            <th className="text-nowrap p-1 text-center" style={{ borderLeft: '2px solid gray', width: '98px' }}>
                                                Time {i + 1}
                                            </th>

                                            <th className="text-nowrap p-1 text-center" style={{ width: '50px' }}>
                                                <div>Repeat</div>
                                                <div className="mt-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`SelectAllRepeat_block_${block}`}
                                                        style={{ border: '1px solid grey' }}
                                                        checked={repeatPatternData[`SelectAllRepeat_block_${block}`] || false}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </th>
                                            <th className="text-nowrap p-1 text-center" style={{ width: '60px' }}>
                                                <div>Next Day</div>
                                                <div className="mt-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`SelectAllNextDay_block_${block}`}
                                                        style={{ border: '1px solid grey' }}
                                                        checked={repeatPatternData[`SelectAllNextDay_block_${block}`] || false}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {days.map((day) => (
                                    <tr key={day}>
                                        <td className="p-1">
                                            <div className="d-flex align-items-center">
                                                <label className="form-check-label m-0">{day}</label>
                                            </div>
                                        </td>
                                        <td className="p-1">
                                            <input
                                                type="text"
                                                name={`${day}time`}
                                                value={repeatPatternData[`${day}time`] || ""}
                                                onChange={handleTimeAutoFormat}
                                                style={{ width: '98px', padding: '0.1rem', paddingLeft: '10px', height: '22px', border: '1px solid lightgray', fontSize: '13px' }}
                                                placeholder="__:__"
                                                inputMode="numeric"
                                                maxLength={5}
                                            />
                                        </td>
                                        {timeBlocks.map((block, i) => (
                                            <React.Fragment key={`${day}_block${i}`}>
                                                <td className="p-1" style={{ borderLeft: '2px solid gray' }}>
                                                    <TimeRangePicker
                                                        name={`${day}_time_${block}`}
                                                        value={repeatPatternData[`${day}_time_${block}`] || ""}
                                                        onChange={handleChange}
                                                        style={{ width: '98px', padding: '0.1rem', height: '22px' }}
                                                    />
                                                </td>
                                                <td className="text-center p-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`${day}_repeat_${block}`}
                                                        checked={repeatPatternData[`${day}_repeat_${block}`] || false}
                                                        onChange={handleChange}
                                                        style={{ width: '14px', height: '12px' }}
                                                    />
                                                </td>
                                                <td className="text-center p-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`${day}_nextDay_${block}`}
                                                        checked={repeatPatternData[`${day}_nextDay_${block}`] || false}
                                                        onChange={handleChange}
                                                        style={{ width: '14px', height: '12px' }}
                                                    />
                                                </td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className='mt-2 mb-2'>
                            <ActionButton title={lang.add_line_button_tooltip} name={lang.add_time_repeat_block_button} btnColor={'info'} onClick={() => setTimeBlocks([...timeBlocks, timeBlocks.length])} />
                            <ActionButton title={lang.clear_button_tooltip} name={lang.clear_button_text} btnColor={'danger'} onClick={() => setTimeBlocks([0, 1, 2])} />
                        </div>
                    </>)}
                </div>
                <div className="mt-3" style={{ marginLeft: "-12px" }}>
                    <ActionButton title="Add" name="Add" btnColor="primary" onClick={handleAddDays} />
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <Grid data={gridData} style={{ height: "200px" }}>
                            <GridColumn field="SlotDate" title={lang.days_column} width={100} />
                            <GridColumn field="Days" title={lang.days_column} width={100} />
                            <GridColumn field="SlotTime" title={lang.time_column} width={100} />
                            <GridColumn field="Duration" title={lang.duration_column} width={100} />
                            <GridColumn field="Title" title={lang.title_column} />
                            <GridColumn field="Genre" title={lang.genre_column} format='Description' cell={ArrayCell} />
                            <GridColumn field="Type.Description" title={lang.type_column} />
                            <GridColumn field="RepeatPattern" title={lang.repeat_pattern_column} cell={CheckboxCell} />
                            <GridColumn
                                field="BreakTemplate"
                                title="Break Template"
                                cell={(props) => <td>{props.dataItem?.BreakTemplate?.Name || props.dataItem?.BreakTemplate || ""}</td>}
                            />
                        </Grid>
                    </div>
                </div>
            </>}
            {showSelectBreakTemplate && (
                <CollectionSelection
                    addButtonTitle={lang.select_button_text}
                    title={lang.select_format_dialog_header}
                    entityname={ENTITYNAME.Format}
                    closeForm={() => setShowSelectBreakTemplate(false)}
                    mode="single"
                    width="50vw"
                    setDataList={handleBreakFormat}
                />
            )}

        </BossDialog>
    );
};

export default PlanningInsertDummyPopup;